import styled, { css } from 'styled-components';

import { ContainedModal } from 'src/components/shared/ContainedModal';
import { FormField, Input } from 'cosmos-components';
import { getScreenBreaks } from 'src/utils/htmlHelper';

export const Container = styled.div`
    font-size: 1rem;
    margin: auto auto 2.5rem auto;
`;

export const ArrivalTimeFormTitle = styled.h3`
    margin-top: 0;
    padding: 0.8rem 0rem;
    border-bottom: 2px solid ${({ theme: { colors } }) => colors.red};
`;

export const BranchInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin: 4rem 0;
`

export const Label = styled.span`
    font-size: 1.4rem;
    font-weight: 600;
`

export const StyledInput = styled(Input)`
    ${({ disabled }) =>
        disabled &&
        css`
            background-color: ${({ theme: { colors } }) => colors.primaryGrey};
        `}
`;

export const StyledFormField = styled(FormField)`
    margin-top: 1.5rem;
    margin-bottom: 0;
    flex: 1 1 0;
    label {
        margin-bottom: 0.5rem;
        height: 100%;
    }
`;

export const Header = styled.div`
    position: relative;
    display: flex;
    font-size: 2rem;
    padding-bottom: 1.5rem;
    margin: 0;
`;

const defaultSpan = styled.span`
    padding-bottom: 0.5rem;
`;

export const Title = styled(defaultSpan)`
    flex-basis: 95%;
    font-size: 1em;
    font-weight: bold;
    padding-bottom: 0.5rem;
`;

export const StyleContainedModal = styled(ContainedModal)`
    & > button {
        margin-top: 0.2rem;
    }
    .rc-dialog {
        width: 100% !important;
        .rc-dialog-body {
            font-size: 1.4rem;
            a {
                color: ${({ theme: { colors } }) => colors.secondaryOrange};
            }
        }
    }
`;

export const AdjacentPairsWrapper = styled.div`
    flex-basis: 50%;
`;

export const PageDescriptionContainer = styled.div`
    font-size: 1.4rem;
    margin-top: 0.8rem;
`;

export const BranchInfoRow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 1.4rem;
`;

export const BranchInfoRowStacked = styled(BranchInfoRow)`
    @media (max-width: ${(props) => getScreenBreaks(props).screenXSMax}) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

export const Value = styled.span`
    font-size: 1.4rem;
`;
